"use client";

import { useRouter } from "next/navigation";
import { useSession } from "next-auth/react";
import { useEffect } from "react";
import dynamic from "next/dynamic";
import { MaxWidthWrapper } from "@/components/global";

const AccountSidebar = dynamic(() => import("./components/AccountSidebar"), {
  loading: () => <p>Loading...</p>,
});

const Forms = dynamic(() => import("./components/Forms"), {
  loading: () => <p>Loading...</p>,
});

const Login = () => {
  const { data: session } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (session?.user.id) {
      router.push("/dashboard/orders");
    }
  }, [session?.user.id]);

  return (
    <>
      <title>Login</title>
      <MaxWidthWrapper className="jlt-mb-32 jlt-pt-[204px]">
        <div className="jlt-grid jlt-grid-cols-1 sm:jlt-grid-cols-2  jlt-gap-0 sm:jlt-gap-8">
          <div className="jlt-p-8 jlt-bg-white jlt-shadow-[0px_0px_35px_rgba(173,173,188,0.1)] jlt-rounded-lg">
            <h5 className="jlt-text-foreground jlt-text-center jlt-text-xl">Login</h5>
            <div className="jlt-mt-12">
              <Forms />
            </div>
          </div>
          <AccountSidebar />
        </div>
      </MaxWidthWrapper>
    </>
  );
};

export default Login;
